/**
 * 描述：预览标题摘要指令
 * 日期：2017-08-08
 * 作者；Bai.Zhiming
 */
"use strict";
angular.module("trsPreviewTitleModule", [])
    .directive('previewTitle', ['$window', '$timeout', function($window, $timeout) {
        return {
            restrict: 'A',
            replace: false,
            transclude: true,
            scope: {
                titleText: '=',
                summaryText: '=',
            },
            /* template: '<div class="preview-title"><a class="limita" data-ng-bind-html="titleText"  ng-click="openTarget()" ng-class="{\'not-read\':notRead==0}"></a>' +
                 '<div class="panel panel-info extra-info" ng-show="extraInfoShow" ng-style="panelpostion"> ' +
                 '<div class="panel-heading" data-ng-bind-html="titleText" ng-hide="hideTitle"></div>' +
                 '<div class="panel-body word-wrap-break-word"><span class="text-red display-inline-block">{{summaryName}}：</span>{{summaryText||noSummaryText}}</div><div class="arrow" ng-style="arrowposition"><div></div></div>',*/
            link: function(scope, $elem, $attrs) {
                $timeout(function() {
                    initStatus();
                });
                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    if (!scope.summaryText) {
                        return;
                    }
                    scope.status = {
                        showHover: false,
                    };
                    initElement();
                    initMouseEnter();
                    initMouseLeave();
                }
                /**
                 * [initElement description] 初始化容器样式
                 * @return {[type]} [description]
                 */
                function initElement() {
                    $elem.css({ position: "relative" });
                }
                /**
                 * [initMouseEnter description] 初始化鼠标移入
                 * @return {[type]} [description]
                 */
                function initMouseEnter() {
                    $elem.bind("mouseenter", function() {
                        var dom = document.createElement("div");
                        dom.innerHTML = scope.summaryText;
                        scope.status.$template = $(["<div class='previewTitle'>",
                            "<div></div>",
                            "<div>",
                            "<span>正文：</span>",
                            "<span>" + dom.innerText + "</span>",
                            "</div>",
                            "<div class='arrow'> </div>",
                            "<div>"
                        ].join(""));
                        $("body").append(scope.status.$template);
                        CorrectDirection();
                    });
                }
                /**
                 * [initDirection description] 修正tip显示的方向 当向下显示空间不足时，自动向上显示
                 * @return {[type]} [description]
                 */
                function CorrectDirection() {
                    var bodyHeight = $("body").height();
                    var parentHeight = $elem[0].offsetHeight;
                    var parentTop = $elem.offset().top;
                    var parentLeft = $elem.offset().left;
                    var templateTop = scope.status.$template.offset().top;
                    var parentWidth = $elem.width() + 50;
                    scope.status.$template.css({ maxWidth: parentWidth });
                    var templateHeight = scope.status.$template[0].offsetHeight;
                    //if ((templateTop + templateHeight) > bodyHeight) {
                    scope.status.$template.css({ top: parentTop - templateHeight - 6, left: parentLeft });
                    scope.status.$template.find(".arrow").css({
                        transform: "rotate(180deg)",
                        top: templateHeight
                    });
                    if (templateHeight > parentTop - 60) {
                        //上面放不下就放下面
                        scope.status.$template.css({ top: parentTop + parentHeight + 6, left: parentLeft });
                        if (templateHeight > bodyHeight - parentHeight - parentTop) { //下面也放不下就加宽
                            scope.status.$template.css({ maxWidth: parentWidth + 50 });
                        }
                        scope.status.$template.find(".arrow").css({
                            transform: "rotate(0deg)",
                            top: -6
                        });
                    }
                }
                /**
                 * [initMouseLeave description] 初始化鼠标移出
                 * @return {[type]} [description]
                 */
                function initMouseLeave() {
                    $elem.bind("mouseleave", function() {
                        $("body").find(".previewTitle").remove();
                    });
                }
            }
        };
    }]);